import { Box } from "@mui/material";
import { FormField } from "empower-energy-owner-components";
import { useEffect, useRef, useState } from "react";

const styles = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  "& .input": {
    width: "80px",
    "& .mui-field": {
      mb: 0,
    },
  },
  "& .unit": {
    width: "90px",
    "& .mui-field": {
      mb: 0,
    },
  },
};

const OFF = "off";
const SECONDS = "seconds";
const MINUTES = "minutes";
const HOURS = "hours";
const DAYS = "days";

const SECOND_CALC = 1;
const MINUTES_CALC = 60;
const HOURS_CALC = 3600;
const DAYS_CALC = 86400;

const SELECT_OPTIONS = [
  { label: OFF, value: OFF },
  { label: SECONDS, value: SECONDS },
  { label: MINUTES, value: MINUTES },
  { label: HOURS, value: HOURS },
  { label: DAYS, value: DAYS },
];

const SecondsSelector = ({ name, value = 0, onChange }) => {
  const [input, setInput] = useState(0);
  const [unit, setUnit] = useState(OFF);
  const lastEmittedSeconds = useRef(value);
  const isFirstLoad = useRef(true);

  useEffect(() => {
    if (!isFirstLoad.current && value === lastEmittedSeconds.current) return;

    if (value === 0) {
      setUnit(OFF);
      setInput(0);
    } else if (value % DAYS_CALC === 0) {
      setUnit(DAYS);
      setInput(value / DAYS_CALC);
    } else if (value % HOURS_CALC === 0) {
      setUnit(HOURS);
      setInput(value / HOURS_CALC);
    } else if (value % MINUTES_CALC === 0) {
      setUnit(MINUTES);
      setInput(value / MINUTES_CALC);
    } else {
      setUnit(SECONDS);
      setInput(value / SECOND_CALC);
    }

    lastEmittedSeconds.current = value;
  }, [value]);

  useEffect(() => {
    let calculatedSeconds = 0;

    if (unit === OFF) {
      calculatedSeconds = 0;
    } else if (unit === SECONDS) {
      calculatedSeconds = input * SECOND_CALC;
    } else if (unit === MINUTES) {
      calculatedSeconds = input * MINUTES_CALC;
    } else if (unit === HOURS) {
      calculatedSeconds = input * HOURS_CALC;
    } else if (unit === DAYS) {
      calculatedSeconds = input * DAYS_CALC;
    }

    if (
      calculatedSeconds !== value &&
      calculatedSeconds !== lastEmittedSeconds.current
    ) {
      lastEmittedSeconds.current = calculatedSeconds;
      isFirstLoad.current = false;

      onChange?.({
        target: {
          name,
          value: calculatedSeconds,
        },
      });
    }
  }, [input, unit]);

  const handleInputChange = (e) => {
    let val = e.target.value.trim();

    if (val === "" || isNaN(val) || !Number.isInteger(Number(val))) {
      val = 0;
    } else {
      val = parseInt(val, 10);
    }

    setInput(val);

    if (val === 0) {
      setUnit(OFF);
    }
  };

  const handleUnitChange = (e) => {
    const newUnit = e.target.value;
    setUnit(newUnit);

    if (newUnit === OFF) {
      setInput(0);
    }
  };

  return (
    <Box sx={styles} className="seconds-selector">
      <Box className="input">
        <FormField
          name="input"
          label=""
          value={input}
          onChange={handleInputChange}
          variant="outlined"
          type="number"
          required
        />
      </Box>
      <Box className="unit">
        <FormField
          name="unit"
          label=""
          value={unit}
          onChange={handleUnitChange}
          variant="outlined"
          type="select"
          options={SELECT_OPTIONS}
          required
        />
      </Box>
    </Box>
  );
};

export default SecondsSelector;
